module.exports = __webpack_public_path__ + "img/bj.fae29632.jpg";